import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { IExtension, IExtensionRelease } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/extensions';
const $urlSetTags = '/admin/extensions/actions/setTags';
const $urlGetReleases = '/admin/extensions/actions/getReleases';

interface IGetRequest {
  state: string;
}

interface IGetResult {
  extensions: IExtension[];
  allTagNames: string[];
  allCount: number;
  pendingCount: number;
  publishedCount: number;
  rejectedCount: number;
}

interface IGetReleasesRequest {
  userName: string;
  name: string;
}

interface IGetReleasesResult {
  releases: IExtensionRelease[];
}

interface IDeleteRequest {
  userName: string;
  name: string;
}

interface ISubmitRequest {
  userName: string;
  name: string;
  state: string;
  message: string;
  isFeatured: boolean;
}

interface ISetTagsRequest {
  userName: string;
  name: string;
  keywords: string[];
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, {
        params: req,
      })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  getReleases(req: IGetReleasesRequest, success: (res: IGetReleasesResult) => void) {
    utils.loading(true);
    request
      .post($urlGetReleases, req)
      .then((response: AxiosResponse<IGetReleasesResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(req: IDeleteRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url, {
        data: req,
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  submit(req: ISubmitRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .put($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  setTags(req: ISetTagsRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .put($urlSetTags, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
